export const muniStations = [
    {
        station: "Chinatown - Rose Pak Station",
        lat: 37.794798495919885, 
        lng: -122.40808097837603,
        artPresent: true
    },
    {
        station: "Union Square - Market St Station",
        lat: 37.78716715227835, 
        lng: -122.4065251938969,
        artPresent: true
    },
    {
        station: "Yerba Buena - Moscone Station",
        lat: 37.7823736239654, 
        lng: -122.40158234091055,
        artPresent: true
    },
    {
        station: "4th & Brannan Station",
        lat: 37.77887415754383, 
        lng: -122.39728016240858,
        artPresent: true
    },
    {
        station: "4th & King Station",
        lat: 37.77612128847838, 
        lng: -122.39388492758128,
        artPresent: false
    },
];